import _ from 'lodash';
import { createSelector } from 'reselect';

const selectSubCompanies = ({ subCompanies }) => subCompanies;

const selectSubCompaniesById = createSelector(selectSubCompanies, subCompanies =>
  _.keyBy(subCompanies, 'id'),
);

export const selectSubCompanyById = id =>
  createSelector(selectSubCompaniesById, subCompaniesById => subCompaniesById[id]);

export const selectExtendedSubCompanies = createSelector(
  [selectSubCompanies, selectSubCompaniesById],
  (subCompanies, subCompaniesById) =>
    subCompanies.map(subCompany => {
      const { parentId, id } = subCompany;

      const parentName = subCompaniesById[parentId]?.name ?? null;
      const isDeletable = !subCompanies.some(subCompany => subCompany.parentId === id);

      return {
        ...subCompany,
        parentName,
        isDeletable,
      };
    }),
);

export const selectAvailableSubCompaniesOptions = _.memoize(subCompanyId =>
  createSelector(selectSubCompanies, subCompanies =>
    subCompanies.reduce((acc, { name, id: value, parentId }) => {
      if (![value, parentId].includes(subCompanyId)) {
        acc.push({
          name,
          value,
        });
      }

      return acc;
    }, []),
  ),
);
